export const GET_BUSINESS_FORM_DATA = 'GET_BUSINESS_FORM_DATA'
export const GET_BUSINESS_FEE_DATA = 'GET_BUSINESS_FEE_DATA'
export const GET_FETCHING_BUSINESS_FORM_DATA_REQUEST_STATUS = 'GET_FETCHING_BUSINESS_FORM_DATA_REQUEST_STATUS'